import type { SVGProps } from "react";
import * as React from "react";

const SvgDroplet = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m12 2.69 5.66 5.66a8 8 0 1 1-11.31 0z"
    />
  </svg>
);
export default SvgDroplet;
